var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinsjPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 388,
    viewBox: "0 0 302 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.677 217.152L0 332.335C17.3118 347.144 43.207 361.635 73.6584 372.334C104.11 383.034 133.378 387.925 156.148 387.199L196.825 272.016C174.055 272.742 144.787 267.851 114.335 257.151C83.8839 246.452 57.9885 231.961 40.677 217.152Z",
    fill: "#1F97FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.908 253.512L196.825 272.016L156.148 387.199L180.232 368.695L220.908 253.512Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.238 260.276C85.3677 250.483 60.3643 237.243 42.2214 222.726L3.88672 331.276C5.99802 333.023 8.22119 334.751 10.5359 336.459C67.4732 332.577 123.042 310.142 166.798 273.514C149.77 271.166 131.436 266.67 113.238 260.276Z",
    fill: "#1F97FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.798 273.514C123.042 310.142 67.4729 332.577 10.5356 336.459C27.6037 349.056 49.9876 360.506 74.7566 369.21C101.824 378.72 129.134 383.958 151.657 383.958C152.373 383.958 153.082 383.952 153.787 383.942L192.118 275.398C184.174 275.387 175.66 274.736 166.798 273.514Z",
    fill: "#A1D5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.25 213.512C116.798 202.812 87.53 197.921 64.7595 198.647L40.6768 217.152C57.9883 231.961 83.8836 246.452 114.335 257.151C144.786 267.851 174.054 272.742 196.825 272.016L220.908 253.512C203.596 238.702 177.701 224.211 147.25 213.512Z",
    fill: "#A1D5F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.932 122.58L123.491 144.754L85.8989 31.2014L140.639 9.30742C143.975 7.97352 147.744 9.72591 148.874 13.1355L182.535 114.828C183.573 117.959 181.994 121.355 178.932 122.58Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.773 73.2527L182.535 114.828",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.32 68.8619L167.739 70.1272",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.369 51.364L111.792 53.8085C113.347 57.9939 116.113 61.3327 119.449 63.4941C120.343 62.2519 121.544 61.0396 122.982 59.9155C121.211 57.5832 119.6 54.6746 118.369 51.364Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.277 41.8757C114.454 41.9634 112.753 41.8298 111.265 41.4729C110.15 45.2889 110.236 49.623 111.792 53.8085L118.369 51.364C117.139 48.0534 116.46 44.7983 116.277 41.8757Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.342 45.0559C136.535 48.2657 137.209 51.4231 137.416 54.2765C139.586 54.0857 141.609 54.1976 143.343 54.6135C144.458 50.7975 144.372 46.4633 142.816 42.2779L135.342 45.0559Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.342 45.0559L142.816 42.2779C141.261 38.0924 138.496 34.7537 135.159 32.5923C134.117 34.0399 132.659 35.4457 130.891 36.7185C132.597 39.0145 134.149 41.8461 135.342 45.0559Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.917 31.2015C115.63 33.1479 112.591 36.9345 111.265 41.473C112.753 41.8299 114.454 41.9635 116.277 41.8758C115.954 36.7092 117.221 32.6188 119.917 31.2015Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.887 30.7776C120.79 30.8139 120.7 30.8635 120.604 30.9017C123.689 29.8857 127.585 32.2717 130.891 36.7185C132.659 35.4457 134.118 34.0399 135.159 32.5923C130.894 29.8294 125.694 28.9911 120.887 30.7776Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.425 65.4004C133.523 65.3662 133.623 65.3453 133.721 65.3089C138.528 63.5224 141.918 59.4916 143.343 54.6136C141.609 54.1976 139.586 54.0857 137.416 54.2766C137.817 59.803 136.425 64.155 133.425 65.4004Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.71 65.6214C129.743 66.3089 126.112 64.0386 122.982 59.9156C121.544 61.0397 120.343 62.252 119.449 63.4942C123.418 66.0649 128.192 66.9471 132.71 65.6214Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.375 40.1601C121.58 41.1989 118.809 41.7538 116.277 41.8757C116.46 44.7983 117.139 48.0533 118.37 51.364L135.342 45.0559C134.149 41.8461 132.598 39.0145 130.891 36.7185C129.034 38.0553 126.837 39.245 124.375 40.1601Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.981 59.9155C124.979 58.354 127.439 56.965 130.234 55.9262C132.696 55.0111 135.137 54.4768 137.416 54.2764C137.209 51.423 136.535 48.2656 135.342 45.0558L118.369 51.3639C119.599 54.6746 121.211 57.5832 122.981 59.9155Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.438 30.9443C120.255 31.0123 120.089 31.1113 119.917 31.2014C120.144 31.0985 120.369 30.9941 120.603 30.9017C120.549 30.9195 120.492 30.9244 120.438 30.9443Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.891 36.7185C127.585 32.2716 123.688 29.8857 120.603 30.9017C120.369 30.9941 120.144 31.0985 119.917 31.2014C117.221 32.6187 115.954 36.7091 116.277 41.8757C118.809 41.7538 121.579 41.1988 124.374 40.1601C126.836 39.245 129.034 38.0553 130.891 36.7185Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.272 65.4756C133.326 65.4557 133.373 65.4221 133.425 65.4003C133.188 65.483 132.949 65.5512 132.71 65.6213C132.899 65.5776 133.09 65.5436 133.272 65.4756Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.981 59.9155C126.112 64.0385 129.742 66.3088 132.71 65.6213C132.949 65.5512 133.188 65.483 133.425 65.4003C136.425 64.1549 137.817 59.803 137.416 54.2764C135.137 54.4768 132.696 55.0111 130.234 55.9262C127.439 56.965 124.979 58.3541 122.981 59.9155Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9393 136.269C95.2896 139.303 93.8663 142.488 92.7193 145.82L69.9886 211.31C68.8922 214.518 72.5855 218.685 78.2376 220.616C83.8899 222.548 89.3606 221.512 90.4571 218.303L113.172 152.858C113.512 151.871 113.898 150.908 114.307 149.959C113.156 149.571 112.061 148.974 111.091 148.159L96.9393 136.269Z",
    fill: "#FF8D69"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.491 144.754L90.0229 43.7662L89.6491 43.452C86.331 40.6643 81.5886 40.3495 77.9311 42.6743L32.2589 71.7052C28.8275 73.8861 28.5036 78.7721 31.6164 81.3874L111.091 148.159C114.409 150.946 119.151 151.261 122.809 148.936L139.398 138.392L123.491 144.754Z",
    fill: "#A1D5F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.301 111.542C143.733 108.077 146.716 105.303 150.246 104.058C149.025 104.078 147.805 104.123 146.587 104.216C141.855 104.993 138.718 110.211 139.565 116.069C139.974 118.896 141.238 121.317 142.969 123.032C141.068 119.551 140.784 115.213 142.301 111.542Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M207.41 139.514C200.195 124.445 187.541 113.096 171.779 107.557C164.748 105.087 157.477 103.94 150.246 104.058C146.716 105.303 143.733 108.077 142.301 111.543C140.784 115.213 141.068 119.551 142.969 123.032C144.858 124.905 147.304 125.933 149.824 125.689V125.701C154.783 125.526 159.782 126.269 164.608 127.965C174.912 131.585 183.185 139.005 187.9 148.856C192.616 158.705 193.209 169.8 189.568 180.096L187.448 186.097C188.446 183.054 190.435 179.792 193.417 176.864C199.703 170.689 207.601 168.536 211.057 172.054C212.425 173.446 212.803 175.581 212.476 177.96C214.928 164.998 213.215 151.64 207.41 139.514Z",
    fill: "#FF8D69"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.771 125.007C171.421 124.833 171.068 124.663 170.713 124.498",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.442 167.213C197.56 160.125 196.031 153.054 192.879 146.472C188.93 138.224 182.786 131.477 175.139 126.855",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8989 31.2015L126.883 0.913473C129.463 -0.992927 133.152 0.221391 134.095 3.28719L136.461 10.9786L85.8989 31.2015Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M156.217 68.7149L116.702 84.5106L118.207 88.276L157.722 72.4803L156.217 68.7149Z",
    fill: "#FF8D69"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M148.721 80.6686L129.482 88.3593L130.988 92.1246L150.227 84.434L148.721 80.6686Z",
    fill: "#FF8D69"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2002 83.1057C82.0347 81.1644 85.0198 78.4802 88.2185 75.476C89.1018 74.6471 90.3347 73.5026 91.1445 72.7668",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7817 72.5744C63.1843 74.458 62.2649 76.7642 62.7822 79.2834C63.2856 81.7455 64.8234 84.0306 66.6979 85.1057C69.9904 86.9945 73.3725 86.4698 76.9848 84.4805",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0681 66.719C79.9966 66.5482 75.7297 66.9146 71.8096 68.0769C70.21 68.5512 68.5047 69.3906 67.0039 70.5093",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0479 78.138C89.3467 77.8583 89.6429 77.5804 89.9358 77.3052C90.8081 76.4861 92.2141 75.3415 93.0144 74.6143",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.668 86.7786C64.9207 86.9601 65.1814 87.1284 65.4497 87.2823C72.7139 91.4485 80.1318 86.1955 86.5259 80.4583",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3234 64.1627C78.5131 64.0961 76.7704 64.23 74.995 64.5289C69.4865 65.4565 63.5961 68.4568 60.986 73.7056C59.4064 76.882 60.0194 80.8899 61.9748 83.9115",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5586 62.7167C73.8396 62.0211 76.2058 61.6121 78.4209 61.6603",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7497 90.3373C71.9877 91.6378 68.0822 91.6842 64.2011 89.459C59.0629 86.5129 56.8476 79.9555 58.0073 74.3218C58.843 70.2613 62.1869 67.1802 65.6669 65.2299C66.5517 64.7341 67.5004 64.2657 68.4899 63.8413",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7998 76.0397C90.3005 80.124 84.3679 86.4081 77.8989 89.4571",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1929 75.3779C82.7469 76.7177 81.242 77.9938 79.689 79.2091C76.9702 81.3366 73.9153 82.9935 70.3467 82.6949",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6665 70.802C88.05 71.5008 87.4182 72.1847 86.7715 72.854",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1763 76.4806C66.1011 71.1829 75.0139 70.0469 78.399 69.4561",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8582 76.9731C75.8936 78.6136 74.3182 79.9619 71.4524 79.8366C70.1753 79.7808 68.8523 79.253 68.0288 78.3154",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3296 71.3289C83.5921 71.9609 82.8677 72.6087 82.1577 73.2716C81.4099 73.9697 80.6413 74.608 79.875 75.2515",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5586 81.7097C67.0137 81.4551 66.5208 81.089 66.1196 80.6407",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9204 68.8619C82.3782 68.6663 83.853 68.5705 85.3213 68.391",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 71.8337C74.6626 72.1545 72.8547 73.2062 71.6181 74.7321C71.1989 75.2493 70.8283 75.9267 71.0514 76.5539C71.2929 77.2331 72.1567 77.5143 72.8581 77.3485C73.5598 77.1827 74.1319 76.6919 74.6742 76.2171C76.0111 75.0463 77.3483 73.8755 78.6852 72.7047",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M106.341 93.0032L77.6709 111.189L106.973 135.808C106.973 135.808 115.118 130.697 118.185 128.743L106.341 93.0032Z",
    fill: "#1F97FC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.532 117.212C112.548 118.049 113.714 118.617 114.935 118.937L108.401 99.2218L102.864 102.455C100.239 103.987 99.9432 107.666 102.289 109.598L103.875 110.905C104.592 111.495 104.502 112.619 103.7 113.087L102.777 113.626C101.157 113.341 98.4731 113.643 97.0292 114.486C94.8996 115.73 93.2538 117.673 95.9301 119.964C99.2968 122.847 106.287 120.637 105.508 115.611C105.475 115.594 105.441 115.577 105.409 115.559C106.592 114.887 107.974 114.281 109.19 115.283L111.532 117.212Z",
    fill: "#082AC8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M255.686 96.4112L257.187 95.7962C256.68 95.9618 256.179 96.1663 255.686 96.4112Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M211.865 164.956C210.011 157.712 211.724 150.086 213.48 142.817C214.879 137.023 218.116 129.527 216.426 123.509C214.632 117.129 208.518 116.024 204.363 119.284C200.924 123.326 199.624 128.696 198.241 133.898C194.396 148.353 190.27 162.823 183.837 176.327C177.405 189.832 168.519 202.43 156.54 211.389L203.273 192.226C209.471 187.592 214.812 181.96 219.442 175.755C215.783 173.344 212.97 169.271 211.865 164.956Z",
    fill: "#1F97FC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M224.948 150.471C224.872 149.777 224.828 149.073 224.809 148.361C224.646 142.309 226.305 135.688 226.138 129.761C226.125 129.282 226.098 128.801 226.056 128.321C225.876 126.255 225.414 124.206 224.618 122.311C224.12 121.126 223.497 119.997 222.709 118.974C222.355 118.514 221.969 118.097 221.569 117.704C221.501 117.637 221.435 117.567 221.365 117.502C220.971 117.133 220.558 116.796 220.129 116.491C220.057 116.441 219.985 116.393 219.912 116.345C218.981 115.716 217.982 115.232 216.94 114.913C216.909 114.904 216.878 114.892 216.847 114.883C216.315 114.725 215.772 114.609 215.224 114.535C215.197 114.531 215.17 114.528 215.143 114.525C213.439 114.308 211.682 114.497 209.998 115.131C209.148 115.45 208.315 115.869 207.518 116.418C206.291 117.264 205.259 118.231 204.363 119.284C208.518 116.024 214.632 117.129 216.426 123.509C218.116 129.527 214.879 137.023 213.48 142.817C211.724 150.086 210.011 157.712 211.865 164.956C212.97 169.271 215.783 173.343 219.442 175.755C223.146 170.789 226.406 165.465 229.209 159.93C226.498 157.203 225.327 153.963 224.948 150.471Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M209.997 115.131L209.998 115.131L209.998 115.131L209.997 115.131Z",
    fill: "#082AC8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M293.8 151.648C289.333 147.339 283.746 146.301 278.733 143.022C267.032 135.371 273.187 121.755 272.873 110.599C272.765 106.764 271.784 102.851 269.444 99.8114C266.428 95.8942 261.615 94.3592 257.21 95.7869L209.997 115.131C214.53 113.426 219.584 114.913 222.71 118.974C225.05 122.013 226.031 125.927 226.139 129.761C226.453 140.918 220.298 154.533 231.999 162.185C237.012 165.463 242.599 166.501 247.067 170.81C251.371 174.962 254.367 180.513 255.235 186.449L256.924 183.912L259.908 184.533L261.597 181.996L264.581 182.616L266.271 180.08L269.255 180.7L270.944 178.163L273.928 178.784L275.617 176.247L278.601 176.868L280.291 174.331L283.275 174.952L284.964 172.415L287.948 173.035L289.637 170.498L292.622 171.119L294.311 168.582L297.295 169.203L298.984 166.666L301.968 167.287C301.101 161.351 298.105 155.8 293.8 151.648Z",
    fill: "#A1D5F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M277.881 161.442C280.536 164.501 282.784 164.604 285.841 163.31C289.608 161.716 289.295 159.772 288.205 158.37C287.143 157.004 285.641 156.47 283.373 156.879C281.491 157.216 280.511 157.415 278.618 157.774C276.149 158.242 274.477 157.851 272.616 156.478C270.412 154.852 270.35 153.627 273.477 152.285C277.59 150.521 280.572 151.331 282.748 152.898",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M272.218 151.35C279.192 154.361 284.108 158.905 286.291 164.85",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M246.037 157.358L261.758 150.917",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M239.077 150.797L266.222 139.675",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M236.662 142.096L257.144 133.704",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M237.91 132L265.054 120.878",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M237.91 122.858L251.482 117.297",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M234.613 113.715L261.758 102.594",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M241.001 160.497C241.859 160.497 242.554 160.035 242.554 159.465C242.554 158.895 241.859 158.432 241.001 158.432C240.144 158.432 239.448 158.895 239.448 159.465C239.448 160.035 240.144 160.497 241.001 160.497Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M229.164 117.338C229.72 117.152 229.991 116.464 229.77 115.8C229.548 115.136 228.918 114.749 228.362 114.935C227.805 115.12 227.534 115.809 227.756 116.473C227.977 117.136 228.608 117.524 229.164 117.338Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M233.221 143.909C233.434 143.081 233.196 142.303 232.689 142.173C232.182 142.043 231.599 142.609 231.386 143.437C231.173 144.266 231.411 145.043 231.918 145.173C232.424 145.304 233.008 144.738 233.221 143.909Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M233.221 133.966C233.434 133.137 233.196 132.36 232.689 132.229C232.182 132.099 231.599 132.665 231.386 133.494C231.173 134.322 231.411 135.1 231.918 135.23C232.424 135.36 233.008 134.794 233.221 133.966Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M234.834 153.148C234.455 154.219 232.734 153.817 232.505 152.602C232.444 152.285 232.464 151.943 232.623 151.662C233.338 150.409 234.911 151.532 234.908 152.68C234.908 152.86 234.881 153.015 234.834 153.148Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M231.027 125.025C231.092 125.239 231.196 125.432 231.335 125.576C231.923 126.183 232.871 125.787 233.016 124.941C233.162 124.086 232.81 122.927 231.82 123.124C231.036 123.281 230.801 124.283 231.027 125.025Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M263.015 161.69C263.888 162.47 265.054 163.851 265.054 163.851L253.051 168.769C253.051 168.769 251.886 167.388 251.012 166.608L263.015 161.69Z",
    fill: "#082AC8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M270.974 164.85C271.689 165.713 272.492 167.236 272.492 167.236L256.516 173.727C256.516 173.727 255.667 172.136 254.998 171.341L270.974 164.85Z",
    fill: "#082AC8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M113.52 131.691L106.972 135.808L102.517 132.064",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M211.057 172.054C207.601 168.536 199.703 170.689 193.417 176.864C190.515 179.714 188.561 182.878 187.538 185.851C187.51 185.933 187.475 186.016 187.448 186.097L185.215 192.42L185.212 192.419L166.611 245.091C165.514 248.3 169.207 252.466 174.86 254.398C180.512 256.329 185.983 255.293 187.079 252.084L209.961 187.307C211.049 184.23 211.882 181.107 212.476 177.96C212.477 177.952 212.478 177.945 212.479 177.937C212.799 175.567 212.42 173.442 211.057 172.054Z",
    fill: "#FF8D69"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103.173 162.608L103.808 160.815",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2471 201.932L102.168 165.445",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M179.07 254.479L183.93 240.755",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M211.057 172.054C207.601 168.536 199.703 170.689 193.417 176.864C190.515 179.714 188.56 182.878 187.538 185.851",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M212.479 177.937C212.799 175.567 212.42 173.442 211.057 172.054",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M166.611 245.091C165.665 247.858 168.281 251.337 172.644 253.481",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M117.099 303.179L74.3184 288.02L65.0941 314.053L107.874 329.212L117.099 303.179Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M107.719 329.284L64.9534 314.129C62.8438 313.381 60.5279 314.485 59.7803 316.595L110.185 334.457C110.932 332.348 109.828 330.032 107.719 329.284Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M100.619 281.403L70.0146 286.622L95.561 295.675L121.107 304.728L100.619 281.403Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3996 309.152C84.3493 312.223 86.2006 313.856 89.1242 314.892C92.728 316.169 94.1403 314.775 94.6222 313.415C95.0922 312.089 94.6103 311.019 92.8959 309.971L89.3434 307.794C87.4882 306.659 86.7738 305.544 87.3639 303.878C88.0629 301.906 89.8768 301.268 92.9535 302.358C96.9994 303.792 97.1933 305.889 96.6498 307.801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8047 301.081L88.416 316.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3052 289.205L68.0801 315.237",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M80.438 290.316L71.2129 316.347",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M110.684 301.034L101.459 327.066",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M113.817 302.145L104.592 328.176",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9886 211.31C68.8922 214.518 72.5855 218.685 78.2376 220.616C83.8899 222.548 89.3606 221.512 90.4571 218.303",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_14777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 273,
    width: 183,
    height: 111
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M166.798 273.514C123.042 310.142 67.4729 332.577 10.5356 336.459C27.6037 349.056 49.9876 360.506 74.7566 369.21C101.824 378.72 129.134 383.958 151.657 383.958C152.373 383.958 153.082 383.952 153.787 383.942L192.118 275.398C184.174 275.387 175.66 274.736 166.798 273.514Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_14777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.099 303.179L74.3184 288.02L65.0941 314.053L107.874 329.212L117.099 303.179Z",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.719 329.284L64.9534 314.129C62.8438 313.381 60.5279 314.485 59.7803 316.595L110.185 334.457C110.932 332.348 109.828 330.032 107.719 329.284Z",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.619 281.403L70.0146 286.622L95.561 295.675L121.107 304.728L100.619 281.403Z",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3996 309.152C84.3493 312.223 86.2006 313.856 89.1242 314.892C92.728 316.169 94.1403 314.775 94.6222 313.415C95.0922 312.089 94.6103 311.019 92.8959 309.971L89.3434 307.794C87.4882 306.659 86.7738 305.544 87.3639 303.878C88.0629 301.906 89.8768 301.268 92.9535 302.358C96.9994 303.792 97.1933 305.889 96.6498 307.801",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8047 301.081L88.416 316.287",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3052 289.205L68.0801 315.237",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.438 290.316L71.2129 316.347",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.684 301.034L101.459 327.066",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.817 302.145L104.592 328.176",
    stroke: "#082AC8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinsjPadlock);
export default __webpack_public_path__ + "static/media/clinsjPadlock.fb05bcb1ec3f6b6e23c733b9c6b287f6.svg";
export { ForwardRef as ReactComponent };